import React, { useState } from 'react';
import css from './LandingPageLoggedOutMenu.css';
import { useHistory } from 'react-router-dom';
import { InlineTextButton, OutsideClickHandler } from '../../../../components';
import { IconChevronBottomStrongM } from '../../../../icons';
import { dropdownsConfig, FIND_HORSE, FIND_SUPPORT, RESOURCES, ABOUT_US } from './dropdowns';
import DropdownHolder from './DropdownHolder';
import classNames from 'classnames';

export default () => {
    const history = useHistory();

    const [selectedId, setSelectedId] = useState(null);

    return [FIND_HORSE, FIND_SUPPORT, RESOURCES, ABOUT_US].map(id => {
        const isOpen = selectedId === id;

        return (
            <OutsideClickHandler
                key={id}
                onOutsideClick={() => {
                    if (isOpen) setSelectedId(null);
                }}
            >
                <InlineTextButton
                    onClick={() => setSelectedId(id)}
                    className={classNames(css.root, {
                        [css.selected]: dropdownsConfig[id].isSelected(history),
                        [css.open]: isOpen,
                    })}
                >
                    <span>{dropdownsConfig[id].label}</span>
                    <code className={css.bottomLine} />
                    <IconChevronBottomStrongM />
                    <DropdownHolder
                        dropdownId={id}
                        rootClassName={css.dropdownItems}
                        isOpen={isOpen}
                    >
                        {dropdownsConfig[id].items}
                    </DropdownHolder>
                </InlineTextButton>
            </OutsideClickHandler>
        );
    });
};
